<template>
    <section id="datapelatihan">
        <div class="rows">
            <!-- <div class="row">
                <b-button  class="button is-primary" 
                tag="router-link"
                to="/admin/berandapelatihan"
                icon-left="arrow-left-bold">Kembali</b-button>
            </div> -->
            <div class="row">
                <div class="box mw-980">
                    <h4 class="title is-5 has-text-centered">{{ actionTitle }} Data Event</h4>
                    <section>
                        <b-field horizontal label="Nama Pelatihan">
                            <b-field  custom-class="is-small has-text-danger" 
                            :type="form.nama_event.type"
                            :message="form.nama_event.message">
                                <b-input name="nama_event" @input="clearError(form.nama_event)"
                                    placeholder="Nama Pelatihan" v-model="form.nama_event.value" expanded></b-input>
                            </b-field>
                        </b-field>

                         <b-field horizontal label="Jenis Event"
                        :type="form.jenis_event.type"
                        :message="form.jenis_event.message">
                         <b-select placeholder="Select one"
                            @input="clearError(form.jenis_event)"  v-model="form.jenis_event.value" expanded>
                                <option value="Workshop Guru">Workshop Guru</option>
                                <option value="Microteaching Siswa">Microteaching Siswa</option>
                            </b-select>
                        </b-field>

                          <b-field horizontal label="Total Rombel"
                        :type="form.total_rombel.type"
                        :message="form.total_rombel.message"
                        v-if="form.jenis_event.value === 'Microteaching Siswa' && (actionTitle === 'Tambah'  || actionTitle === 'Ubah')"
                        v-model="form.total_rombel.value" >
                        <b-numberinput v-model="form.total_rombel.value" @input="clearError(form.total_rombel)" min="1"></b-numberinput>
                        </b-field>


                        <b-field horizontal label="Tanggal Event">
                         <b-field  custom-class="is-small has-text-danger" 
                            :type="form.tgl_event.type"
                            :message ="form.tgl_event.message">
                                <b-datepicker
                                    ref="datepicker" 
                                    v-model="form.tgl_event.value"
                                    placeholder="Select a date">
                                     <b-button
                                    label="Clear"
                                    type="is-danger"
                                    icon-left="close"
                                    outlined
                                    @click="form.tgl_event.value = '' " />
                                </b-datepicker>
                                <b-button
                                    @click="$refs.datepicker.toggle()"
                                    icon-left="calendar-today"
                                    type="is-primary">
                                </b-button>
                         </b-field>
                        </b-field>
                        <b-field horizontal  label="Tempat Event">
                         <b-field  custom-class="is-small has-text-danger" 
                        :type="form.tempat_event.type"
                        :message="form.tempat_event.message">
                            <b-input name="tempat_event" @input="clearError(form.tempat_event)"
                                placeholder="Tempat Event" v-model="form.tempat_event.value" expanded></b-input>
                         </b-field>
                        </b-field>

                        <b-field label="Deskripsi Kegiatan" horizontal>
                            <b-field  custom-class="is-small has-text-danger" 
                            :type="form.deskripsi.type"
                            :message="form.deskripsi.message">
                                <b-input maxlength="500" type="textarea" name="deskripsi" @input="clearError(form.deskripsi)"
                                    placeholder="Deskripsi" v-model="form.deskripsi.value" expanded
                                ></b-input>
                            </b-field>
                        </b-field>

                        <b-field horizontal label="Pembicara">
                            <b-field custom-class="is-small has-text-danger" 
                            :type="form.pembicara.type"
                            :message="form.pembicara.message">
                                <b-input name="pembicara" @input="clearError(form.pembicara)"
                                    placeholder="Pembicara" v-model="form.pembicara.value" expanded></b-input>
                            </b-field>
                        </b-field>
                        
                        <b-field horizontal  label="Peserta">
                            <b-field  custom-class="is-small has-text-danger" 
                            :type="form.peserta.type"
                            :message="form.peserta.message">
                                <b-input name="peserta" @input="clearError(form.peserta)"
                                    placeholder="Peserta" v-model="form.peserta.value" expanded></b-input>
                            </b-field>
                        </b-field>


                        <b-field horizontal label="Link Materi">
                            <b-field custom-class="is-small has-text-danger" 
                            :type="form.linkdrive.type" 
                            :message="form.linkdrive.message">
                            <ckeditor
                                :editor="editor"
                                v-model="form.linkdrive.value"
                                :config="editorConfig"
                                @input="clearError(form.linkdrive)"
                            ></ckeditor>
                            </b-field>
                        </b-field>

                        <b-field horizontal label="Link Presensi">
                            <b-field custom-class="is-small has-text-danger" 
                            :type="form.link_presensi.type" 
                            :message="form.link_presensi.message">
                            <ckeditor
                                :editor="editor"
                                v-model="form.link_presensi.value"
                                :config="editorConfig"
                                @input="clearError(form.link_presensi)"
                            ></ckeditor>
                            </b-field>
                        </b-field>

                        <b-field horizontal label="Url Yotube">
                            <b-field custom-class="is-small has-text-danger" 
                            :type="form.url_youtube.type" 
                            :message="form.url_youtube.message">
                            <ckeditor
                                :editor="editor"
                                v-model="form.url_youtube.value"
                                :config="editorConfig"
                                @input="clearError(form.url_youtube)"
                            ></ckeditor>
                            </b-field>
                        </b-field>

                        <b-field horizontal label="Jumlah Peserta">
                            <b-field  custom-class="is-small has-text-danger" 
                            :type="form.jml_peserta.type"
                            :message="form.jml_peserta.message"
                            v-model="form.jml_peserta.value" >
                            <b-numberinput v-model="form.jml_peserta.value" @input="clearError(form.jml_peserta)" min="1"></b-numberinput>
                            </b-field>
                        </b-field>
                        
                        <b-field horizontal label="Picture Event">
                            <b-field  custom-class="is-small has-text-danger" 
                            :type="form.pic_event.type"
                            :message="form.pic_event.message">
                                <b-upload v-model="form.pic_event.value" accept="image/*" @input="readImagePic" drag-drop >
                                <section class="section">
                                    <div class="content has-text-centered">
                                    <p v-if="upload">
                                        <b-icon icon="upload" size="is-medium">
                                        </b-icon>
                                    </p>
                                    <p v-if="upload">
                                        Drop your files here or click to upload
                                    </p>
                                    
                                    <div class="image-preview" v-if="preview">
                                        <img class="preview" :src="gambarEvent">
                                    </div>
                                    <div class="image-preview" v-if="previewEdit">
                                        <img class="preview" :src="gambarEvent">
                                    </div>
                                    </div>
                                </section>
                                </b-upload>
                            </b-field>
                        </b-field>
                        <div class="tags">
                        <span class="tag is-primary" v-if="preview">
                            {{ form.pic_event.value.name }}
                            <button
                            class="delete is-small"
                            type="button"
                            @click="deleteDropFile()"
                            disabled
                            ></button>
                        </span>

                        <span class="tag is-primary" v-if="previewEdit">
                            {{ form.pic_event.value }}
                            <button
                            class="delete is-small"
                            type="button"
                            @click="deleteDropFile()"
                            ></button>
                        </span>
                        </div>
                        
                        <!-- <b-field horizontal>
                            <p class="control">
                                <button class="button is-primary"
                                    @click="confirm()">
                                Simpan
                                </button>
                            </p>
                        </b-field> -->
                    </section>
                    <div class="rows" style="margin-top: 24px">
                        <div class="row">
                            <div class="columns">
                                <div class="column">
                                    <b-button type="is-danger" 
                                    class="mw-420" 
                                    tag="router-link"
                                    to="/biro/berandapelatihan">Batal</b-button>
                                </div>
                                <div class="column">
                                    <b-button type="is-info" class="mw-420" @click="confirm()">Simpan</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-loading
            :is-full-page ="true"
            :active.sync="isLoading"
            :can-cancel="false">
        </b-loading>
    </section>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor";
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize";
//import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
//image
// import Image from '@ckeditor/ckeditor5-image/src/image';
// import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
// import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
// import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
// import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Link from "@ckeditor/ckeditor5-link/src/link";
import List from "@ckeditor/ckeditor5-list/src/list";
import ListStyle from "@ckeditor/ckeditor5-list/src/liststyle";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableCellProperties from "@ckeditor/ckeditor5-table/src/tablecellproperties";
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount";
    export default {
        data() {
            return {
               editorData: "<p>Isi Content News</p>",
            editor: ClassicEditor,
            editorConfig: {
                plugins: [
                // Alignment,
                Autoformat,
                Autosave,
                // BlockQuote,
                // Bold,
                // Essentials,
                // FontColor,
                // FontFamily,
                // FontSize,
                //Heading,
                // Highlight,
                // Indent,
                // IndentBlock,
                // Italic,
                // Image,
                // ImageCaption,
                // ImageStyle,
                // ImageToolbar,
                // ImageUpload,
                Link,
                // List,
                ListStyle,
                // Paragraph,
                PasteFromOffice,
                Strikethrough,
                // Subscript,
                // Superscript,
                // Table,
                // TableCellProperties,
                // TableProperties,
                // TableToolbar,
                // Underline,
                // WordCount,
                ],
                toolbar: [
                //"heading",
                // "|",
                // "undo",
                // "redo",
                // "|",
                // "bold",
                // "italic",
                // "underline",
                "link",
                // "bulletedList",
                // "numberedList",
                // "|",
                // "alignment:left",
                // "alignment:center",
                // "alignment:right",
                // "alignment:justify",
                // "|",
                // "indent",
                // "outdent",
                // "insertTable",
                // "blockQuote",
                // "|",
                // "fontFamily",
                // "fontColor",
                // "fontSize",
                // "highlight",
                // "strikethrough",
                // "subscript",
                // "superscript"
                ],
        // wordCount: {
        //   displayWords: true,
        // },
                },
                isLoading:false,
                actionTitle:'',
                editId:0,
                gambarEvent:'',
                tgl_event:[],
                dataEvent: new FormData(),
                editDataEvent:{},
                form:
                {
                   nama_event:{
                       value:'', type:'', message:''
                   },
                   tgl_event:{
                        value:'', type:'', message:''
                   },
                   tempat_event:{
                       value:'', type:'', message:''
                   },
                    deskripsi:{
                       value:'', type:'', message:''
                   },
                    pembicara:{
                       value:'', type:'', message:''
                   },
                   peserta:{
                       value:'', type:'', message:''
                   },
                   linkdrive:{
                       value:'', type:'', message:''
                   },
                   link_presensi:{
                       value:'', type:'', message:''
                   },
                    url_youtube:{
                       value:'', type:'', message:''
                   },
                    jml_peserta:{
                       value:'', type:'', message:''
                   },
                   jenis_event:{
                       value:'', type:'', message:''
                   },
                    total_rombel:{
                       value:1, type:'', message:''
                   },
                   pic_event:{
                        value:'', type:'', message:''
                   },
                    id_biro: { 
                        value: null , type: '', message: '' 
                    },
                },
                snackbarMessage:'',
                biros:[],
                upload: true,
                total_rombel: 1,
                jml_peserta : 1,
                preview: false,
                previewEdit: false,
                // activeBiro:Object,
                config: {}
            };
        },
        methods:{
            readImagePic(){
                this.clearError(this.form.pic_event)
                var input = this.form.pic_event.value
                
                if(input){
                    var reader = new FileReader()
                    reader.readAsDataURL(input)
                    reader.onload = (e) => {
                    this.gambarEvent = e.target.result
                    }
                }
                this.upload = false
                this.preview = true
            },

            deleteDropFile() {
                this.form.pic_event.value = ''
                this.upload = true
                this.preview = false
                this.previewEdit = false
            },
            getData(editId) {
                var uri = this.$apiUrl + "event/" + editId

                this.$http.get(uri, this.config).then(response => {
                    this.editDataEvent = response.data.value
                    this.formEditHandler(this.editDataEvent) 
                })
            },
            getEventByBiro()
            {
                var uri = this.$apiUrl + 'event/biro/' + this.detailId 
                this.$http.get(uri, this.config).then(response=>
                {
                    this.event = response.data.value
                })
            },
            formEditHandler(dataEvent) { 
                console.log(dataEvent)
                this.form.nama_event.value = dataEvent.nama_event
                this.form.tempat_event.value = dataEvent.tempat_event
                this.form.deskripsi.value = dataEvent.deskripsi
                this.form.pembicara.value = dataEvent.pembicara
                this.form.pic_event.value = dataEvent.pic_event
                this.form.peserta.value = dataEvent.peserta
                this.form.linkdrive.value = dataEvent.linkdrive
                if(dataEvent.link_presensi !== null){
                    this.form.link_presensi.value = dataEvent.link_presensi
                }
                if(dataEvent.url_youtube !== null){
                    this.form.url_youtube.value = dataEvent.url_youtube
                }
                this.form.jenis_event.value = dataEvent.jenis_event
                this.form.total_rombel.value = dataEvent.total_rombel
                this.form.jml_peserta.value = dataEvent.jml_peserta
                this.form.id_biro.value = dataEvent.id_biro
            
                if(dataEvent.tgl_event !== null){
                    this.form.tgl_event.value = new Date(dataEvent.tgl_event);
                }
                this.gambarEvent = this.$apiUrl + 'event/picture/' + dataEvent.pic_event
                this.upload = false
                this.previewEdit = true
            },
            clearError(form) {
                console.log(form)
                form.type = ''
                form.message = '' 
            },
            cekData() 
            {
                let count = 0
                let regexAngka = new RegExp(/^\d+$/)

                if(this.form.nama_event.value === "") {
                    this.form.nama_event.type = 'is-danger'
                    this.form.nama_event.message = "Nama Event Harus diisi!"
                    count++
                }
                if(this.form.tempat_event.value === "") {
                    this.form.tempat_event.type = 'is-danger'
                    this.form.tempat_event.message = "Tempat Event Harus diisi!"
                    count++
                }
                if(this.form.deskripsi.value === "") {
                    this.form.deskripsi.type = 'is-danger'
                    this.form.deskripsi.message = "Deskripsi Event Harus diisi!"
                    count++
                }
                if(this.form.tgl_event.value === "") {
                    this.form.tgl_event.type = 'is-danger'
                    this.form.tgl_event.message = "Tanggal Event Harus diisi!"
                    count++
                }
                 if(this.form.jenis_event.value === "") {
                    this.form.jenis_event.type = 'is-danger'
                    this.form.jenis_event.message = "Jenis Event Harus diisi!"
                    count++
                }
                if(this.form.pembicara.value === "") {
                    this.form.pembicara.type = 'is-danger'
                    this.form.pembicara.message = "Pembicara Event Harus diisi!"
                    count++
                }
                if(this.form.peserta.value === "") {
                    this.form.peserta.type = 'is-danger'
                    this.form.peserta.message = "Peserta Event Harus diisi!"
                    count++
                }
                if(this.form.jml_peserta.value === "" || this.form.jml_peserta.value === 0) {
                    this.form.jml_peserta.type = 'is-danger'
                    this.form.jml_peserta.message = "Jumlah Peserta Guru Harus diisi!"
                    count++
                }
                if(!regexAngka.test(this.form.jml_peserta.value) || this.form.jml_peserta.value < 0)
                {
                    this.form.jml_peserta.type ='is-danger'
                    this.form.jml_peserta.message ="Jumlah peserta berupa angka dan tidak bisa minus"
                    count ++
                }
                if(this.form.linkdrive.value === "") {
                    this.form.linkdrive.type = 'is-danger'
                    this.form.linkdrive.message = "Link Materi Harus diisi!"
                    count++
                }
                if(this.form.pic_event.value === "") {
                    this.form.pic_event.type = 'is-danger'
                    this.form.pic_event.message = "Picture harus diisi dan hanya 1 gambar!"
                    count++
                }
                if(this.form.pic_event.value.size > 2000000) {
                    this.form.pic_event.type = 'is-danger'
                    this.form.pic_event.message = "File Picture terlalu besar(max 2MB) !"
                    count++
                }
                if(this.form.total_rombel.value === "" || this.form.total_rombel.value === "")
                {
                    this.form.total_rombel.type ='is-danger'
                    this.form.total_rombel.message ="Total Rombel harus diisi"
                    count ++
                }
                if(!regexAngka.test(this.form.total_rombel.value) || this.form.total_rombel.value < 0)
                {
                    this.form.total_rombel.type ='is-danger'
                    this.form.total_rombel.message ="Total Rombel berupa angka dan tidak bisa minus"
                    count ++
                }

            console.log(count)

            if(count > 0)
                return false
            },
             convertTgl(tglEvent) {
                var formDate = tglEvent 
                var year = formDate.getFullYear()       
                var month = formDate.getMonth() + 1      
                var date = formDate.getDate()            

                month = (month < 10) ? '0' + month : month
                date = (date < 10) ? '0' + date : date

                 var fixedDate = year + '-' + month + '-' + date //sebelum
                // var fixedDate =   date + '-' + month + '-' + year //sesudah

                return fixedDate
            },
            addData() 
            {
                this.isLoading = true // Biar dia loading dulu
                
                if(this.cekData() == false) {
                    this.snackbar("Gagal tambah data. Silahkan Input Lagi...", 'is-danger')
                    this.isLoading = false
                } else {

                    console.log(this.form)
                    
                    this.dataEvent.append("nama_event", this.form.nama_event.value)
                    this.dataEvent.append("tempat_event", this.form.tempat_event.value)
                    this.dataEvent.append("deskripsi", this.form.deskripsi.value)
                    this.dataEvent.append("pembicara", this.form.pembicara.value)
                    this.dataEvent.append("peserta", this.form.peserta.value)
                    this.dataEvent.append("linkdrive", this.form.linkdrive.value)
                    this.dataEvent.append("link_presensi", this.form.link_presensi.value)
                    this.dataEvent.append("url_youtube", this.form.url_youtube.value)
                    this.dataEvent.append("jml_peserta", this.form.jml_peserta.value)
                    this.dataEvent.append("total_rombel", this.form.total_rombel.value)
                    this.dataEvent.append("jenis_event", this.form.jenis_event.value)
                    this.dataEvent.append("pic_event", this.form.pic_event.value)
                    if(this.form.tgl_event.value !== ""){
                            this.dataEvent.append("tgl_event",this.convertTgl(this.form.tgl_event.value))
                        }else{
                        this.dataEvent.tgl_event = this.form.tgl_event.value
                        }
                    // this.dataEvent.append("id_biro", this.activeBiro.id_biro)

                    var uri = this.$apiUrl + "event";

                    this.$http.post(uri, this.dataEvent, this.config).then(response => {
                    this.isLoading = false
                    this.snackbarMsg = response.message
                    this.$router.push({name: 'BerandaPelatihanAdmin'})
                    this.snackbar("Data berhasil ditambahkan", 'is-success')
                    })
                    .catch(error => {
                    this.isLoading = false
                    this.errors = error;
                    if (this.errors.message == "Request failed with status code 400") {
                        this.snackbar("Gagal tambah data.Silahkan Input Lagi", 'is-danger')
                    } else {
                        this.snackbar("Terjadi kesalahan. Silahkan coba lagi", 'is-danger')
                    }
                    })
                }
                // this.isLoading = false 
            },

             editData(editId) {
                this.isLoading = true 

                if(this.cekData() == false) {
                    this.snackbar("Gagal tambah data. Sepertinya inputan salah...", 'is-danger')
                    this.isLoading = false
                } else {
                    // console.log(this.form)
                    this.dataEvent.append("nama_event", this.form.nama_event.value)
                    this.dataEvent.append("tempat_event", this.form.tempat_event.value)
                    this.dataEvent.append("deskripsi", this.form.deskripsi.value)
                    this.dataEvent.append("pembicara", this.form.pembicara.value)
                    this.dataEvent.append("peserta", this.form.peserta.value)
                    this.dataEvent.append("jenis_event", this.form.jenis_event.value)
                    this.dataEvent.append("total_rombel", this.form.total_rombel.value)
                    this.dataEvent.append("linkdrive", this.form.linkdrive.value)
                    this.dataEvent.append("link_presensi", this.form.link_presensi.value)
                    this.dataEvent.append("url_youtube", this.form.url_youtube.value)
                    this.dataEvent.append("jml_peserta", this.form.jml_peserta.value)
                     if(this.form.tgl_event.value !== ""){
                        this.dataEvent.append("tgl_event", this.convertTgl(this.form.tgl_event.value))
                    }else{
                        this.dataEvent.tgl_event = this.form.tgl_event.value
                    }

                    // this.dataEvent.append("id_biro", this.detailId)
                    if(typeof(this.form.pic_event.value) !== 'string') { 
                        this.dataEvent.append("pic_event", this.form.pic_event.value) 
                    }
                    if( this.form.id_biro.value !== null)
                    {
                        this.dataEvent.append("id_biro", this.form.id_biro.value)
                    }
                    // console.log(this.form)

                    var uri = this.$apiUrl + "event/" + editId;

                    this.$http.post(uri, this.dataEvent, this.config).then(response => {
                    this.isLoading = false
                    this.$router.push( { name: 'BerandaPelatihanAdmin' } )
                    this.snackbarMsg = response.message
                    this.snackbar("Data berhasil diedit", 'is-success')
                    })
                    .catch(error => {
                    this.errors = error;
                    this.isLoading = false
                    if (this.errors.message == "Request failed with status code 400") {
                        this.snackbar("Edit gagal. Sepertinya inputan salah...", 'is-danger')
                    } else {
                        this.snackbar("Terjadi kesalahan. Silahkan coba lagi", 'is-danger')
                    }
                    })
                }
                // this.isLoading = false 
            },
        confirm() {
            this.editId == 0 ? this.addData() : this.editData(this.editId)
        },
        snackbar(snackbarMessage, type)
        {
        this.$buefy.toast.open({
            duration: 5000,
            message: snackbarMessage,
            type: type,
            position: 'is-top',
            actionText: 'OK',
            queue: false,
            })
        },     
     },
     watch: {
        pic_event: function(o) {
        var reader = new FileReader();
        reader.onload = e => this.$emit("load", e.target.result);
        reader.readAsText(o[0]);
        alert();
        }
    },
     mounted() {
      if(this.$session.exists()){
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
          }
         } 
      }
        if(this.$route.params.id) {           
        this.editId = this.$route.params.id 
        this.actionTitle = 'Ubah'           
        this.getData(this.editId)          
        } else {                      
        this.actionTitle = 'Tambah' 
        }
        // this.isLoading = false 
    }
       
}
</script>

<style scoped>
  img.preview {
    width: 200px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
  }
  .mw-980 {
    max-width: 980px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .mw-420 {
    max-width: 420px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
</style>